
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import { all_routes } from "../feature-module/router/all_routes";
import { useEffect, useState } from "react";
import "../style/css/custom.css";
import React from "react";
import { getUserLoginData } from "../core/data/redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatbotFloatingButton from "../core/common/chatbotFloatingButton";
import { getApplicationModulesAPI } from "../core/data/redux/applicationModulesSlice";
import Error404 from "./pages/error/error-404";
import { getStaffQuarterPermissions, getStaffQuarterAdminPermissions } from "../core/data/redux/staffQuarterSlice";
import { tokenService } from "../core/utils/tokenService";

const SLUG_ALIASES: Record<string, string[]> = {
  all_leave_tab: ["leave_management_applications", "all_leave_tab"],
  leave_management_applications: ["all_leave_tab", "leave_management_applications"],
  reimbursement_claims_advances_all: ["reimbursement_claims_advances", "reimbursement_claims_advances_all"],
  reimbursement_claims_advances: ["reimbursement_claims_advances_all", "reimbursement_claims_advances"],
  employee_apar: ["employee_appraisal_performance_management", "employee_apar"],
  employee_appraisal_performance_management: ["employee_apar", "employee_appraisal_performance_management"],
};

const getSlugForPathname = (pathname: string): string | null => {
  const path = pathname.toLowerCase().replace(/\/$/, "");

  if (path.startsWith("/staff-quarters")) {
    return "staff_quarter_applications";
  }
  if (path.startsWith("/employee-leave") || path.startsWith("/leave-management")) {
    return "all_leave_tab";
  }
  if (path.startsWith("/reimbursement")) {
    return "reimbursement_claims_advances_all";
  }
  if (path.startsWith("/annual-property-return")) {
    return "annual_property_return_submission";
  }
  if (path.startsWith("/services/id-card/inclusion-dependent")) {
    return "inclusion_of_dependent_parents_including_widow_mother";
  }
  if (path.startsWith("/services/id-card/deletion-dependent")) {
    return "deletion_of_dependent_parents_including_widow_mother";
  }
  if (path.startsWith("/services/id-card/family-inclusion")) {
    return "list_of_inclusion_deletion_of_family_members_spouse_children";
  }
  if (path.startsWith("/id-card") || path.startsWith("/id-card-management") || path.startsWith("/services/id-card")) {
    return "application_for_new_icard";
  }
  if (path.startsWith("/change-password")) {
    return "change_password";
  }
  if (path.startsWith("/dar-case") || path.startsWith("/dar")) {
    return "dmrc_employee_discipline_and_appeal_rules";
  }
  if (path.startsWith("/esepration")) {
    return "dmrc_employee_e_separation_module";
  }
  if (path.startsWith("/post-promotional") || path.startsWith("/post-promotion") || path.startsWith("/probation")) {
    return "dmrc_promotion_of_employees_process";
  }
  if (path.startsWith("/due-drawn")) {
    return "due_drawn";
  }
  if (path.startsWith("/e-requisition-it")) {
    return "e_requisition_it";
  }
  if (path.startsWith("/employee-who-is-who")) {
    return "who_is_who_employee_directory_search";
  }
  if (path.startsWith("/multiple-salary-statement")) {
    return "multiple_salary_statement";
  }
  if (path.startsWith("/police-verification")) {
    return "police_verification";
  }
  if (path.startsWith("/services/vpf-contribution") || path.startsWith("/vpf")) {
    return "employee_vpf_contribution_module";
  }
  if (path.startsWith("/services/appeal-contribution")) {
    return "appeal_for_contribution";
  }
  if (path.startsWith("/services/community-hall")) {
    return "booking_of_community_hall_common_room_park";
  }
  if (path.startsWith("/services/annual-nps-superannuation")) {
    return "annual_nps_superannuation_application";
  }
  if (path.startsWith("/services/annual-pf-details")) {
    return "annual_pf_details";
  }
  if (path.startsWith("/salary-statement-hindi") || path.startsWith("/salary-statement-english") || path.startsWith("/salary-statement") || path.startsWith("/services/salary-statement")) {
    return "salary_statement";
  }
  if (path.startsWith("/noc/outside-job")) {
    return "noc_for_outside_job";
  }
  if (path.startsWith("/noc/passport-visa")) {
    return "noc_for_passport_visa";
  }
  if (path.startsWith("/noc/higher-education")) {
    return "noc_for_higher_education";
  }
  if (path.startsWith("/noc/ex-india")) {
    return "noc_for_ex_india_foreign_visit";
  }
  if (path.startsWith("/noc/online-course")) {
    return "noc_reimbursement_addition_of_online_course";
  }
  if (path.startsWith("/services/e-attestation") || path.startsWith("/e-attestation")) {
    return "e_attestation_process";
  }
  if (path.startsWith("/sap-authorization") || path.startsWith("/services/sap-authorization")) {
    return "sap_authorization_form";
  }
  if (path.startsWith("/sv4-card")) {
    return "sv4_card_issue_reissue";
  }
  if (path.startsWith("/tax-simplifier-statement") || path.startsWith("/services/tax-simplifier")) {
    return "tax_simplifier_statement";
  }
  if (path.startsWith("/services/display-tax-card")) {
    return "display_tax_card";
  }
  if (path.startsWith("/services/loan-surety")) {
    return "loan_surety_status_check";
  }
  if (path.startsWith("/services/authority-letter-health-checkup")) {
    return "authority_letter_for_annual_comprehensive_health_checkup";
  }
  if (path.startsWith("/services/staff-welfare-fund")) {
    return "staff_welfare_fund_grants";
  }
  if (path.startsWith("/services/leave-encashment")) {
    return "leave_encashment_for_el_beyond_60_leave";
  }
  if (path.startsWith("/services/medical-attendance")) {
    return "prior_approval_for_ivf_para_6_2_6_3_treatment";
  }
  if (path.startsWith("/services/self-transfer")) {
    return "self_transfer";
  }
  if (path.startsWith("/services/transfer-applications")) {
    return "employee_transfer_posting_module";
  }
  if (path.startsWith("/apar")) {
    return "employee_apar";
  }
  if (path.startsWith("/birthday-anniversaries")) {
    return "birthday_and_anniversaries";
  }
  if (path.startsWith("/public-holidays")) {
    return "public_holiday";
  }
  if (path.startsWith("/manager-self-service")) {
    return "manager_self_service_module";
  }

  return null;
};

const Feature = () => {

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getUserLoginData({}));
  }, [])

  const routes = all_routes;

  const { data: applicationModulesResponse, loading } = useSelector((state: any) => state.applicationModulesState || {});
  const applicationModules = applicationModulesResponse?.data || [];

  const { permissions: sqPermissions, adminPermissions, loading: sqLoading } = useSelector((state: any) => state.staffQuarterState || {});

  useEffect(() => {
    if (loading === "idle") {
      dispatch(getApplicationModulesAPI({ page: 1, limit: 100, orderColumn: "name", orderBy: "ASC" }));
    }
  }, [dispatch, loading]);

  useEffect(() => {
    const token = tokenService.getToken() || "";
    if (token && sqLoading === "idle") {
      dispatch(getStaffQuarterPermissions({}));
      dispatch(getStaffQuarterAdminPermissions({}));
    }
  }, [dispatch, sqLoading]);

  useEffect(() => {
    const token = tokenService.getToken() || "";
    if (!token) {
      return window.location.replace(routes.login);
    }
  });

  const headerCollapse = useSelector((state: any) => state.themeSetting.headerCollapse);
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  const miniSidebar = useSelector(
    (state: any) => state.sidebarSlice.miniSidebar
  );
  const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);
  const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector((state: any) => state.themeSetting.dataSidebarAll);
  const dataColorAll = useSelector((state: any) => state.themeSetting.dataColorAll);
  const dataTopBarColorAll = useSelector((state: any) => state.themeSetting.dataTopBarColorAll);
  const dataTopbarAll = useSelector((state: any) => state.themeSetting.dataTopbarAll);
  const location = useLocation();
  useEffect(() => {
    if (dataTheme === "dark_data_theme") {
      document.documentElement.setAttribute("data-theme", "darks");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const user = localStorage.getItem("user");
  const userJson = user && user != 'undefined' ? JSON.parse(user) : {};
  let userType = userJson?.user_type || userJson?.role;

  const rawModules = applicationModulesResponse;
  let modulesArray: any[] = [];
  if (Array.isArray(rawModules)) {
    modulesArray = rawModules;
  } else if (rawModules && Array.isArray(rawModules.data)) {
    modulesArray = rawModules.data;
  } else if (Array.isArray(applicationModules)) {
    modulesArray = applicationModules;
  } else if (applicationModules && Array.isArray(applicationModules.data)) {
    modulesArray = applicationModules.data;
  }

  const currentSlug = getSlugForPathname(location.pathname);
  let isModuleDisabled = false;

  if (userType === 'EMPLOYEE' && currentSlug && modulesArray.length > 0) {
    const slugsToCheck = [currentSlug, ...(SLUG_ALIASES[currentSlug] || [])];
    const module = modulesArray.find((mod: any) => slugsToCheck.includes(mod.slug));
    if (module && module.status === false) {
      isModuleDisabled = true;
    }
  }

  // Check Staff Quarter specific permissions
  let isSqPermissionDenied = false;
  if (userType === 'EMPLOYEE' && location.pathname.toLowerCase().startsWith("/staff-quarters")) {
    const path = location.pathname.toLowerCase().replace(/\/$/, "");
    const roles = adminPermissions?.roles || [];

    // Check role-based blocking:
    if (path.startsWith("/staff-quarters/manage") || path.startsWith("/staff-quarters/inventory")) {
      // 1. Staff Quarter Management root check:
      // If roles list is populated and contains only "EMPLOYEE", block all manage/inventory routes.
      if (roles.length > 0 && !roles.some((r: string) => r !== "EMPLOYEE")) {
        isSqPermissionDenied = true;
      }

      // 2. Inbox route check:
      if (path.startsWith("/staff-quarters/manage/requests")) {
        const hasApprover = roles.some((r: string) => r.toUpperCase().includes("APPROVER"));
        if (!hasApprover) {
          isSqPermissionDenied = true;
        }
      }

      // 3. Inventory route check:
      if (path.startsWith("/staff-quarters/inventory")) {
        if (!roles.includes("HR_ADMIN")) {
          isSqPermissionDenied = true;
        }
      }
    }

    if (path.includes("setting-staff-quarter-approval") || path.includes("staff-quarter-approval")) {
      if (userType === 'EMPLOYEE') {
        const roles = adminPermissions?.roles || [];
        const isHrAdmin = roles.includes("HR_ADMIN") || roles.some((r: string) => r.toLowerCase().includes("hr") && r.toLowerCase().includes("admin"));
        if (!isHrAdmin) {
          isSqPermissionDenied = true;
        }
      }
    }

    const sqPermissionsList = Array.isArray(adminPermissions?.permissions)
      ? adminPermissions.permissions
      : (Array.isArray(sqPermissions) ? sqPermissions : []);
    if (sqPermissionsList && sqPermissionsList.length > 0) {
      // 1. registration
      if (path === "/staff-quarters/new" || path === "/staff-quarters/new-registration") {
        const perm = sqPermissionsList.find((p: any) => p.module === "registration");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 2. priority-list
      if (path.includes("/manage/priority-list")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "priority-list");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 3. willingness
      if (path.includes("/willingness")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "willingness");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 4. occupation (occupation / withdrawal)
      if (path === "/staff-quarters/occupation" || path === "/staff-quarters/withdrawal" || path.includes("/occupation-withdrawal")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "occupation");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 5. vacation (vacation intimation)
      if (path.includes("/vacation-intimation")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "vacation");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 6. export (reports / export)
      if (path.includes("/reports") || path.includes("/export")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "export");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 7. inventory
      if (path.includes("/inventory")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "inventory");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
      // 8. allotment
      if (path.includes("/allotments") || path.includes("/allotment")) {
        const perm = sqPermissionsList.find((p: any) => p.module === "allotment");
        if (perm && perm.canView === false) {
          isSqPermissionDenied = true;
        }
      }
    }
  }

  if (isModuleDisabled || isSqPermissionDenied) {
    return <Error404 />;
  }

  return (
    <>
      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
    `}
      </style>
      <div
        className={`
        ${dataLayout === "mini" || dataWidth === 'box' ? "mini-sidebar" : ''}
        ${dataLayout === "horizontal" || dataLayout === "horizontal-single" || dataLayout === "horizontal-overlay" || dataLayout === "horizontal-box" ? 'menu-horizontal' : ''}
       ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
       ${dataWidth === 'box' ? 'layout-box-mode' : ''} ${headerCollapse ? "header-collapse" : ""}
      ${(expandMenu && miniSidebar) ||
            (expandMenu && dataLayout === "mini")
            ? "expand-menu"
            : ""
          }
       
       `}
      >
        <div
          className={`main-wrapper 
            ${mobileSidebar ? "slide-nav" : ""}`}
        >
          <Header />
          <Sidebar />
          <Outlet />
        </div>

        <div className="sidebar-overlay"></div>

        {/* Toast Container for react-toastify */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {/* Floating Chatbot Button */}
        <ChatbotFloatingButton />
      </div>
    </>
  );
};

export default Feature;
